// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"927cb9ef","109":"0c1a1f5b","144":"5e942ebe","220":"5e942ebe","522":"5e942ebe","824":"5e942ebe"}[chunkId] + ".chunk.css";
};